import { render, staticRenderFns } from "./ModeleForm.vue?vue&type=template&id=45e993e6&"
import script from "./ModeleForm.vue?vue&type=script&lang=js&"
export * from "./ModeleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports